import React, { useState, useEffect } from 'react';
import { Col, FormGroup, Label, InputGroup, InputGroupAddon } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

/**
 * Single date picker for selecting a planned end date.
 * @param viewTaskData - task object with existing plannedEndDate
 * @param onPlannedEndDateChange - callback with selected date in 'YYYY-MM-DD' format
 */
function TasksEndDatePicker({ viewTaskData, onPlannedEndDateChange }) {
  const [plannedEndDate, setPlannedEndDate] = useState(null);

  useEffect(() => {
    if (viewTaskData && viewTaskData.plannedEndDate) {
      const parsed = new Date(viewTaskData.plannedEndDate);
      if (!isNaN(parsed)) {
        setPlannedEndDate(parsed);
      }
    }
  }, [viewTaskData]);

  const handleDateChange = (date) => {
    setPlannedEndDate(date);
  
    if (onPlannedEndDateChange && date) {
      // Get current time
      const now = new Date();
      const hours = now.getHours().toString().padStart(2, '0');
      const minutes = now.getMinutes().toString().padStart(2, '0');
      const seconds = now.getSeconds().toString().padStart(2, '0');
  
      // Format selected date
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
  
      // Combine date + current time
      const fullDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  
      onPlannedEndDateChange(fullDateTime);
    }
  };
  

  return (
    <Col md={6} className="mt-1 mb-1">
      <FormGroup>
        <Label><b>Planned End Date:</b></Label>
        <InputGroup>
          <InputGroupAddon addonType="prepend">
            <div className="input-group-text">
              <FontAwesomeIcon icon={faCalendarAlt} />
            </div>
          </InputGroupAddon>
          <DatePicker
            selected={plannedEndDate}
            onChange={handleDateChange}
            dateFormat="yyyy-MM-dd"
            className="form-control"
            placeholderText="Select end date"
            minDate={new Date()}
          />
        </InputGroup>
      </FormGroup>
    </Col>
  );
}

export default TasksEndDatePicker;
